<template>
  <div class="player-card-parts" @click="emitClick">
    <figure class="player-card-parts__img">
      <img :src="imgPath" alt="" />
    </figure>

    <div class="player-card-parts__data">
      <p class="player-card-parts__data__name">
        {{ name || $t('common.favoriteNotSet') }}
      </p>
      <p v-if="team" class="player-card-parts__data__team">
        {{ team }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * レーサー 表示パーツ
 * todo: デザイン調整 / props設定 / emit等
 */
export default defineComponent({
  name: 'PlayerCardParts',
  props: {
    img: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    team: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    /**
     * imgPath
     * @param {string} val 画像データパス
     */
    const imgPath = computed({
      get: () => props.img || './assets/img/common/card/icon_player__null.svg',
      set: (val: string) => val,
    })

    return {
      imgPath,
    }
  },
  methods: {
    /**
     * 押下されたことを通知
     */
    emitClick() {
      this.$emit('click')
    },
  },
})
</script>

<style lang="scss" scoped>
.player-card-parts {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__img {
    img {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 2px;
    }
  }

  &__data {
    display: flex;
    flex-flow: column nowrap;
    align-content: flex-start;
    justify-items: center;
    width: calc(100% - 64px);
    text-align: left;

    &__name {
      @include fontSetTextMedium();

      font-weight: 600;
      line-height: 1.38;
      color: $black;
    }

    &__team {
      @include fontSetTextSmall();

      color: $black50;
    }
  }

  &__arrow {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
}
</style>
